import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PermissionService } from '../../../services/permission.service';
import { ActionButtonComponent } from '../../atoms/action-button/action-button.component';
import { CancelLinkComponent } from '../../atoms/cancel-link/cancel-link.component';
import { HelpButtonComponent } from '../help-button/help-button.component';

@Component({
  selector: 'app-form-footer',
  standalone: true,
  imports: [ActionButtonComponent, CancelLinkComponent, HelpButtonComponent],
  templateUrl: './form-footer.component.html',
  styleUrl: './form-footer.component.scss',
})
export class FormFooterComponent {
  @Input() helpKey?: string;
  @Input() hideCancelLink = false;
  @Input() cancelLevel = 1; // Controls the level for the cancel link
  @Input() isEditMode = false; // Whether we're in edit or add mode
  @Input() showRemoveButton = false; // Controls visibility of remove button
  @Output() removeClick = new EventEmitter<void>(); // Emits when remove button is clicked
  @Output() cancel = new EventEmitter<void>(); // Emits when remove button is clicked

  constructor(public permissionService: PermissionService) {}

  /**
   * Handles the remove click action and emits an event to signal that the action has occurred.
   *
   * @return {void} This method does not return any value.
   */
  onRemoveClick(): void {
    this.removeClick.emit();
  }

  /**
   * Handles the cancel button click event.
   * Emits a cancel event to notify listeners about the action.
   *
   * @return {void} No return value.
   */
  onCancelClick(): void {
    this.cancel.emit();
  }
}
